export default {
	state: {
		regimeTributacao: {}
	},
	getters: {
		"regimeTributacao": state => state.regimeTributacao
	},
	mutations: {
		setRegimeTributacao(state, payload) {
			state.regimeTributacao = payload
		}
	},
	actions: {
		atualizarEstadoRegimeTributacao({ commit }, payload) {
			commit('setRegimeTributacao', payload)
		}
	}
};